export enum MessengerViewVariant {
  CHAT_LIST = "chatList",
  CHAT_BY_ID = "chatById",
  CHAT_BY_USER = "chatByUser",
  CHAT_PARTICIPANTS = "chatParticipants",
  PROFILE = "profile",
}
